export const OvalStyle: React.CSSProperties = {
    height: '30px',
    width: '30px',
    borderRadius: '100px',
}